import React, { AnchorHTMLAttributes } from 'react';
import Link from '~/components/Link';
import LinkExternal from '../LinkExternal';
interface CustomLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
}
export const MarkdownLink: React.FC<CustomLinkProps> = ({
  href,
  children,
  id
}: CustomLinkProps): React.ReactElement<CustomLinkProps> => {
  const isToc = href.startsWith('#');
  const handleScrollToTarget = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
    const targetId = href.replace('#', '');
    const targetElemet = document.getElementById(targetId);
    if (targetElemet) {
      e.preventDefault();
      targetElemet.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return isToc ? <Link color="link" href={href} id={id} onClick={handleScrollToTarget} underline="none" data-sentry-element="Link" data-sentry-component="MarkdownLink" data-sentry-source-file="index.tsx">
      {children}
    </Link> : <LinkExternal color="link" href={href} kioskModeFallback={href} data-sentry-element="LinkExternal" data-sentry-component="MarkdownLink" data-sentry-source-file="index.tsx">
      {children}
    </LinkExternal>;
};
export default MarkdownLink;